import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';

import * as fromComponents from './components';
import { FluidheightDirective } from './directive/fluidheight.directive';
import { ImageUploaderComponent } from './directive/image-uploader.component';
import { ProgressBarComponent } from './directive/progressbar.component';
import { CustDateOnlyPipe, CustDatePipe, CustDateNoTimeConversionPipe, GetKeyPipe, formatTimeForScreen, HighlightPipe } from './pipes/safe.pipe';
import { VideojsWavesurferComponent } from '@app/pages/common/videojs-wavesurfer/videojs-wavesurfer.component';
import { CallTranscriptComponent } from '@app/pages/common/call-transcript/call-transcript.component';
import { CleanStringPipe } from './pipes/clean-string.pipe';
import { EnterClickDirective } from './directive/enter-click.directive';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TinymceRichTextEditorComponent } from '@app/Common/tinymce-rich-text-editor/tinymce-rich-text-editor.component';
@NgModule({
    declarations: [
        TinymceRichTextEditorComponent,
        GetKeyPipe,
        CustDatePipe,
        CustDateOnlyPipe,
        CustDateNoTimeConversionPipe,
        FluidheightDirective,
        EnterClickDirective,
        ...fromComponents.components,
        ProgressBarComponent,
        ImageUploaderComponent,
        VideojsWavesurferComponent,
        CallTranscriptComponent, formatTimeForScreen,
        HighlightPipe,
        CleanStringPipe
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TableModule,EditorModule],
    exports: [
        GetKeyPipe,
        CustDatePipe,
        CustDateOnlyPipe,
        CustDateNoTimeConversionPipe,
        FluidheightDirective,
        EnterClickDirective,
        ...fromComponents.components,
        ProgressBarComponent,
        ImageUploaderComponent,
        VideojsWavesurferComponent,
        CallTranscriptComponent,
        formatTimeForScreen,
        HighlightPipe,
        CleanStringPipe,
        TinymceRichTextEditorComponent,
        EditorModule
    ],
})
export class SharedModule { }
